import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';
import { validate } from '@adornis/validation/decorators.js';
import { nonOptional } from '@adornis/validation/functions/nonOptional.js';

@Entity()
export class Timeframe extends MongoEntity {
  static override _class = 'Timeframe';
  static override _collectionName = 'timeframes';

  @validate(nonOptional())
  @Field(type => String)
  public name!: string;

  @validate(nonOptional())
  @Field(type => Date, { default: v => v ?? new Date() })
  public from!: Date;

  @validate(nonOptional())
  @Field(type => Date, { default: v => v ?? new Date() })
  public till!: Date;

  @validate(nonOptional())
  @Field(type => String)
  public institutionID!: string;

  @validate(nonOptional({ allowFalsy: true }))
  @Field(type => Boolean, { default: v => v ?? false })
  public isActive!: boolean;

  @validate(nonOptional())
  @Field(type => Date)
  publishDate?: Date;

  @validate(nonOptional({ allowFalsy: true }))
  @Field(type => Boolean, { default: v => v ?? false })
  public isRegistrationPossibleBesidesTimeframe!: boolean;

  // date when the timeframe-mails should be sent automatically
  @Field(type => Date)
  sd_sendSemesterMail: Maybe<Date>;

  // date of last 'sendSemesterMailToAllParticipantsInTimeframe' trigger
  @Field(type => Date)
  sd_lastSendSemesterMail: Maybe<Date>;
}
